<template>
  <v-autocomplete
    v-model="RELATORIO_SELECIONADO_COMPUTED"
    label="Selecione o tipo de relatório"
    :items="items"
    item-text="descricao"
    item-value="id"
    return-object
    hide-details
    outlined
    dense
    class="mb-2 font-weight-regular"
  />
</template>

<script>
import $axios from "@/api/api";
import {computed, onMounted} from "vue";

export default {
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: Object
  },
  emits: ['update:modelValue'],
  setup(props, ctx) {
    const items = [
      {
        id: 0,
        descricao: 'Cotação em Excel',
        url: `${$axios.defaults.baseURL}/relatorios/compra/cotacao/fornecedores/produtos-combinados/excel`
      },
      {
        id: 1,
        descricao: 'Cotação em PDF',
        url: `${$axios.defaults.baseURL}/relatorios/compra/cotacao/fornecedores/produtos-combinados/pdf`
      }
    ];

    const RELATORIO_SELECIONADO_COMPUTED = computed({
      get: () => props.modelValue,
      set: valor => ctx.emit('update:modelValue', valor),
    });
    onMounted(() => RELATORIO_SELECIONADO_COMPUTED.value = items[0]);

    return {
      items,
      RELATORIO_SELECIONADO_COMPUTED
    }
  }
}
</script>
